module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-104.26986c8.woff2";